import React from "react";

import "./Synonyms.css";

export default function Synonyms(props) {
  if (props.synonyms.length !== 0) {
    return (
      <div className="Synonyms">
        <p className="ms-4 fs-6 fw-normal mb-0 opacity-50 text-decoration-underline">
          <em>synonyms</em>
        </p>
        <ul>
          {props.synonyms.map(function (synonym, index) {
            return <li key={index}>{synonym}</li>;
          })}
        </ul>
      </div>
    );
  } else {
    return null;
  }
}
